<template>
  <div>
    <div class="search-box gauge_20">
      <div class="form">
        <div class="input-item">
          <span class="label">展示机构</span>
          <selectTree type="3" v-model="searchObj.showOrgIds"></selectTree>
        </div>

        <div class="input-item">
          <span class="label">图片名称</span>
          <Input v-model="searchObj.picName" placeholder="请输入" clearable />
        </div>

        <div class="input-item">
          <span class="label">内容标题</span>
          <Input v-model="searchObj.picTitle" placeholder="请输入" clearable />
        </div>

        <div class="input-item">
          <span class="label">有效期</span>
          <DatePicker
            :clearable="true"
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="searchObj.validDate"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </DatePicker>
        </div>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="initBannerList">查询</Button>
        <Button @click="reset">重置</Button>
        <Button type="primary" class="add-btn" @click="$refs.popUpChange.open({})">新增</Button>
      </div>
    </div>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box setTable">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="picName">
          <div>
            <a class="txt-ellipsis2" @click="$refs.popUpChange.open(row)" :title="row.picName">{{ row.picName }}</a>
          </div>
        </template>

        <template slot-scope="{ row, index }" slot="mobilePic">
          <div class="img-box">
            <img :src="row.mobilePic" :preview="index" :key="row.mobilePic"/>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <div class="action-box">
            <div class="action-btn">
              <a @click="$refs.popUpChange.open(row)">编辑</a>
              <a @click="submitDelete(row)">删除</a>
            </div>
          </div>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page
        :total="total"
        :current="searchObj.pageNo"
        :page-size="searchObj.pageSize"
        show-total
        @on-change="pageChange"
        style="text-align: center"
      />
    </div>

    <!-- 新增-编辑 -->
    <pop-up-change ref="popUpChange" :initBannerList="initBannerList"></pop-up-change>

  </div>
</template>

<script>
import filters from "@/api/filter";
import selectTree from "@/components/system/selectTree3";
import popUpChange from "./components/popUpChange";
export default {
  name: "popUpConfig",
  components: {
    selectTree,
    popUpChange
  },
  filters,
  data() {
    return {
      total: 0,
      searchObj: {
        pageNo: 1,
        pageSize: 10,
        configType: 2,
      },
      tableData: [],
      columns: [
        {
          title: "图片名称",
          align: "center",
          minWidth:300,
          slot: "picName",
        },
        {
          title: "弹出图片",
          align: "center",
          minWidth: 300,
          slot: "mobilePic",
        },
        {
          title: "跳转类型",
          minWidth: 100,
          align: "center",
          render(h, params) {
            const jumpType = params.row.jumpType;
            let type
            if(jumpType =='1'){
              type = '链接'
            }else if(jumpType =='2'){
              type = '产品'
            }else if(jumpType =='4'){
              type = '活动'
            }
            return <span>{type}</span>;
          },
        },
        {
          title: "内容标题",
          minWidth: 300,
          align: "center",
          key: "picTitle",
          tooltip: true,
          render(h, params) {
              let text = params.row.picTitle;
              return h(
                  'Tooltip',
                  {
                      class:'flex-center',
                      props: { placement: 'bottom-start', transfer: true }
                  },
                  [
                      h(
                          'span',
                          {
                              class: 'txt-ellipsis2'
                          },
                          text
                      ),
                      h('span', { slot: 'content'}, text)
                  ]
              );
          }
        },
        {
          title: "有效期",
          minWidth: 250,
          align: "center",
          render(h, params) {
            const effectTimeStart = params.row.effectTimeStart;
            const effectTimeEnd = params.row.effectTimeEnd;
            let str = `${
              effectTimeStart && effectTimeEnd
                ? filters.filterTime(effectTimeStart, "YYYY-MM-DD") +
                  "至" +
                  filters.filterTime(effectTimeEnd, "YYYY-MM-DD")
                : "持续生效"
            }`;
            return <span>{str}</span>;
          },
        },
        {
          title: "创建时间",
          minWidth: 160,
          align: "center",
          render(h, params) {
            const result = params.row.createTime;
            return (
              <span>
                {filters.filterTime(result, "YYYY-MM-DD HH:mm") || "-"}
              </span>
            );
          },
        },
        {
          title: "操作",
          minWidth: 80,
          align: "center",
          slot: "action",
          fixed: "right"
        },
      ],
    };
  },
  created() {
    this.initBannerList();
  },
  methods: {
    // 处理请求参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchObj));
      if (obj.validDate && obj.validDate[0]) {
        obj.effectTimeStart = filters.filterTime(
          obj.validDate[0],
          "YYYY-MM-DD"
        );
        obj.effectTimeEnd = filters.filterTime(obj.validDate[1], "YYYY-MM-DD");
      }
      obj.showOrgIds = obj.showOrgIds?[obj.showOrgIds]:[];
      
      delete obj.validDate;
      let { ...params } = obj;
      return params;
    },

    // 查询
    initBannerList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/exhibitionPicConfig/read/list",
        type: "POST",
        data: this.setRequestParam(),
        apiPermissionCode:'operate_3_0'
      }).then((res) => {
        this.total = res.total;
        this.tableData = res.data;
        this.$root.$children[0].isShowLoading = false;
        this.$units.delTableFixedPreview();
      });
    },

    // 重置
    reset() {
      this.searchObj = {
        pageNo: 1,
        pageSize: 10,
        configType: 2,
      };
      this.initBannerList();
    },

    // 删除
    submitDelete(item) {
      this.$notice.inquiry("确认删除操作？").then(async () => {
        this.$http({
          url: `/buz/exhibitionPicConfig/del?id=${item.id}`,
          type: "GET",
          apiPermissionCode:'operate_3_6'
        }).then((res) => {
          this.$Message.success("删除成功");
          this.initBannerList();
        });
      });
    },

    // 分页
    pageChange(pageNo) {
      this.searchObj.pageNo = pageNo;
      this.initBannerList();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  .form {
    width: 95%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .input-item {
      display: flex;
      align-items: center;
      padding-right: 50px;
    }
    .label {
      min-width: 60px;
      font-size: 13px;
    }
    /deep/ .ivu-input {
      font-size: 13px;
    }
    /deep/ .ivu-select-selected-value {
      font-size: 13px;
    }
  }
  /deep/ .add-btn {
    background: #f59045 !important;
    border: none;
  }
  /deep/ .add-btn {
    background: #f59045 !important;
    border: none;
  }
  .btn-item {
    /deep/ .ivu-btn {
      font-size: 13px;
    }
  }
}
.setTable {
  .img-box {
    img {
      width: 30%;
    }
  }
  .pic-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .action-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    .action-btn {
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
/deep/ .setTable .ivu-table th .ivu-table-cell {
  font-size: 12px;
  font-weight: bold;
  color: #272933;
}
/deep/ .ivu-table-tip {
  font-size: 12px;
}
.pageBox {
  margin-top: 20px;
}
</style>